module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNTU2Yjc5IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8cGF0aCBkPSJNNyAxMGw1IDUgNS01eiIvPg0KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4NCjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// C:/Users/Sjurdur.B10/Documents/hscamping/calendar/src/assets/arrowdown.svg
// module id = 183
// module chunks = 1